module.exports = __webpack_public_path__ + "static/media/bg.0bb489db.png";